module.exports = __webpack_public_path__ + "media/images/defaults/citizen_science_project_image/small-11da44f45a272a66eecacd7b951a608e.png";